// API Store Module

import CfgApi from "@/assets/cfg/CfgApi.json";
import CfgForms from "@/assets/cfg/CfgForms.json";
import * as Utils from "@/utils/utils.js";
import * as ApiUtils from "@/utils/api_utils.js";
import { m } from "@/utils/utils";

const state = {
	wait: false,
	waitStack: [],
	sourceName: CfgApi.defaultSourceName,
	source: CfgApi.sources[CfgApi.defaultSourceName],
	CfgApi: CfgApi,
	CfgForms: CfgForms,
};

const getters = {
	state: state => {return state}, // this whole namepaced state
}

const mutations = {
	mutWaitPush: (state, id) => {
		state.waitStack.push(id);
		state.wait = (state.waitStack.length>0);
	},
	mutWaitPull: (state, id) => {
		const idx = state.waitStack.indexOf(id);
		if (idx>=0) state.waitStack.splice(idx,1);
		state.wait = (state.waitStack.length>0);
	},
	mutWaitClear: (state) => {
		state.waitStack = [];
		state.wait=false;
	},
	mutSetDataSource: (state, payload) => {
		const { name } = payload;
		m("api mut set data source", name);
		state.sourceName = name;
		state.source = CfgApi.sources[name];
	}
}

const actions = {
	setDataSource: ({ commit, dispatch }, payload) => {
		m("api act set data source", payload);
		commit("mutSetDataSource", payload);
	},

	toggleWait: ({ commit }, id) => {
		let wait_id = id;

		if (wait_id) {
			if (wait_id=="clear") {
				commit("mutWaitClear");
			} else {
				commit("mutWaitPull", wait_id);
			}
		} else {
			wait_id = Utils.genWord(6);
			commit("mutWaitPush", wait_id);
		}

		m("wait stack: " + state.waitStack.length, state.waitStack);
		return wait_id;
	},

	sendRequest: ({ commit, dispatch }, payload) => {
		m('api action: send request', payload);
		const pkg = ApiUtils.buildFormPkg(payload);
		if (pkg.ok) {
			ApiUtils.sendHttpRequest(pkg);
		} else {
			m("form build error");
			m(pkg.mess);
			
			const data = {
				step: "form pkg",
				trx: "error",
				mess: pkg.mess,
			}
			dispatch("app/updTrxStatus", data,{ root: true });

		}
	},

}


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}